import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from "@angular/core";

@Component({
  selector: 'visitor-mobile-services',
  templateUrl: './mobile-services.component.html',
  styleUrls: ['./mobile-services.component.css']
})
export class MobileServicesComponent implements OnInit {

  @Output() 
  open: EventEmitter<any> = new EventEmitter();

  public value: any = 1;
  
  constructor() { }

  ngOnInit(): void {
  }

  openSidebarLeft(){
    this.value = this.value + 1 
    this.open.emit(this.value);

  }

}
